import { useGetSpaPackage } from '@features/spa';
import moment from 'moment';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { usePackageConfiguration } from '../../contexts';
import { FormStep, PackagesFormValues } from '../../types';
import { useGroupOptionsByDateAndOptionGroup } from '../hooks/useGroupOptionsByDate';
import { buildExperienceSlots, getChoiceGroupDefinitions } from './buildExperienceSlots';

export const useExperienceSlots = (experienceStep: FormStep | undefined) => {
  const {
    property,
    language,
    journeyParams,
    spaPackageId,
    stayDuration,
    spaGuestAmount,
    packageType,
    isRepeatedFlexibleEnabled,
  } = usePackageConfiguration();
  const { watch } = useFormContext<PackagesFormValues>();
  const selectedExperiences = watch('selectedExperiences');

  const { data: spaDay } = useGetSpaPackage(
    Number(property.id),
    Number(spaPackageId),
    language,
    true
  );
  const packageConfigGroups = useMemo(
    () => (Array.isArray(spaDay?.configurationGroups) ? spaDay.configurationGroups : []),
    [spaDay?.configurationGroups]
  );

  const selectedExperiencesWithoutExtras = useMemo(
    () => (selectedExperiences || []).filter((exp) => exp.type !== 'spa-extras'),
    [selectedExperiences]
  );

  const experiencesByDay = useGroupOptionsByDateAndOptionGroup(
    moment(journeyParams.fromDate),
    selectedExperiencesWithoutExtras,
    packageType,
    stayDuration,
    spaGuestAmount,
    packageConfigGroups,
    isRepeatedFlexibleEnabled
  );

  const choiceGroups = useMemo(
    () => (experienceStep ? getChoiceGroupDefinitions(experienceStep, packageType) : []),
    [experienceStep, packageType]
  );

  const slots = useMemo(
    () =>
      buildExperienceSlots({
        includedGroups: experiencesByDay.flatMap(({ options }) => options),
        choiceGroups,
      }),
    [experiencesByDay, choiceGroups]
  );

  return { spaDay, packageConfigGroups, slots };
};
